module.exports = __webpack_public_path__ + "static/media/grandcanyon2.6fc7345b.jpg";